export function useFinancialYears(count = 5){
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < count; i++) {
      const start = currentYear - i;
      const end = start + 1;
      years.push(`${start}-${end}`);
    }
    return years;
};